var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIdleChip = function SvgIconIdleChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M14.492 13.558 11.125 10.5H8.867L5.5 13.558a3 3 0 0 0-.792 3.342 3.025 3.025 0 0 0 2.834 1.933h4.908a3.02 3.02 0 0 0 2.833-1.933 3 3 0 0 0-.791-3.342m-2.975 2.059H8.483a.567.567 0 0 1-.566-.567c0-.308.258-.567.566-.567h3.034c.316 0 .566.259.566.567a.573.573 0 0 1-.566.567M15.292 4.097a3.03 3.03 0 0 0-2.833-1.933H7.542A3.026 3.026 0 0 0 5.509 7.44l3.366 3.058h2.258L14.5 7.44a3.03 3.03 0 0 0 .792-3.342m-3.775 2.425H8.484a.567.567 0 0 1-.567-.566c0-.309.258-.567.567-.567h3.033c.317 0 .567.258.567.567a.573.573 0 0 1-.567.566"
  })));
};
export default SvgIconIdleChip;